module.exports = __webpack_public_path__ + "static/media/INVOICE.bfc0790e.svg";